export default [
  {
    path: '/underReview',
    component: () => import('@/layouts/navigationIndex.vue'),
    children: [
      {
        path: 'new',
        name: 'underReview-new',
        component: () => import('@/pages/Sales/UnderReview/Edit.vue'),
        meta: {
          pageTitle: 'underReview',
          breadcrumb: [{ text: 'sales', active: true }],
          permission: 'addUnderProcedureTransaction',
        },
      },
      {
        path: 'edit/:id',
        name: 'underReview-edit',
        props: true,
        component: () => import('@/pages/Sales/UnderReview/Edit.vue'),
        meta: {
          pageTitle: 'underReview',
          breadcrumb: [{ text: 'sales', active: true }],
          permission: 'editUnderProcedureTransaction',
        },
      },
    ],
  },
  {
    path: '/concrete-under-review',
    component: () => import('@/layouts/navigationIndex.vue'),
    children: [
      {
        path: 'new',
        name: 'concrete-under-review-new',
        component: () => import('@/pages/Sales/ConcreteUnderReviewTransaction/Edit.vue'),
        meta: {
          pageTitle: 'concreteUnderReview',
          breadcrumb: [{ text: 'sales', active: true }],
          permission: 'addUnderProcedureTransaction',
        },
      },
      {
        path: 'edit/:id',
        name: 'concrete-under-review-edit',
        props: true,
        component: () => import('@/pages/Sales/ConcreteUnderReviewTransaction/Edit.vue'),
        meta: {
          pageTitle: 'concreteUnderReview',
          breadcrumb: [{ text: 'sales', active: true }],
          permission: 'editUnderProcedureTransaction',
        },
      },
    ],
  },
  {
    path: '/sales-order',
    component: () => import('@/layouts/navigationIndex.vue'),
    children: [
      {
        path: 'new',
        name: 'sales-order-new',
        component: () => import('@/pages/Sales/SalesOrder/Edit.vue'),
        meta: {
          pageTitle: 'salesOrder',
          breadcrumb: [{ text: 'sales', active: true }],
          permission: 'addSalesOrders',
        },
      },
      {
        path: 'edit/:id',
        name: 'sales-order-edit',
        props: true,
        component: () => import('@/pages/Sales/SalesOrder/Edit.vue'),
        meta: {
          pageTitle: 'salesOrder',
          breadcrumb: [{ text: 'sales', active: true }],
          permission: 'editSalesOrders',
        },
      },
    ],
  },
  {
    path: '/reservations',
    component: () => import('@/layouts/navigationIndex.vue'),
    children: [
      {
        path: 'new',
        name: 'reservations-new',
        component: () => import('@/pages/Sales/Reservition/Edit.vue'),
        meta: {
          pageTitle: 'reservations',
          breadcrumb: [{ text: 'sales', active: true }],
          permission: 'addReservations',
        },
      },
      {
        path: 'edit/:id',
        name: 'reservations-edit',
        props: true,
        component: () => import('@/pages/Sales/Reservition/Edit.vue'),
        meta: {
          pageTitle: 'reservations',
          breadcrumb: [{ text: 'sales', active: true }],
          permission: 'editReservations',
        },
      },
    ],
  },
  {
    path: '/contracts',
    component: () => import('@/layouts/navigationIndex.vue'),
    children: [
      {
        path: 'new',
        name: 'contracts-new',
        component: () => import('@/pages/Sales/Contracts/Edit.vue'),
        meta: {
          pageTitle: 'contracts',
          breadcrumb: [{ text: 'sales', active: true }],
          permission: 'addContractTransaction',
        },
      },
      {
        path: 'edit/:id',
        name: 'contracts-edit',
        props: true,
        component: () => import('@/pages/Sales/Contracts/Edit.vue'),
        meta: {
          pageTitle: 'contracts',
          breadcrumb: [{ text: 'sales', active: true }],
          permission: 'editContractTransaction',
        },
      },
    ],
  },
  {
    path: '/restaurant-menu',
    name: 'restaurant-menu',
    component: () => import('@/pages/Sales/RestaurantMenu/Edit.vue'),
    meta: {
      pageTitle: 'restaurantMenu',
      breadcrumb: [{ text: 'sales', active: true }],
      permission: 'viewResturantOrders',
    },
  },
  {
    path: '/point-of-sale',
    name: 'point-of-sale',
    component: () => import('@/pages/Sales/PointOfSale/PosEntry.vue'),
    meta: {
      pageTitle: 'pointOfSale',
      breadcrumb: [{ text: 'sales', active: true }],
      permission: 'addSalesTransactions',
    },
  },
  {
    path: '/point-of-sale-v2',
    name: 'point-of-sale-v2',
    redirect: { name: 'point-of-sale' },
  },
  {
    path: '/sales-dashboard',
    name: 'invoice-dashboard',
    component: () => import('@/pages/Sales/SalesDashboard/Edit.vue'),
    meta: {
      pageTitle: 'salesDashboard',
      breadcrumb: [{ text: 'sales', active: true }],
      permission: 'viewPurchDashboard',
    },
  },
  {
    path: '/invoice-list',
    name: 'invoice-list',
    component: () => import('@/pages/Sales/List.vue'),
    meta: {
      pageTitle: 'salesPoint',
      breadcrumb: [{ text: 'sales', active: true }],
      permission: 'viewTransactions',
    },
  },
  {
    path: '/invoice',
    component: () => import('@/layouts/navigationIndex.vue'),
    children: [
      {
        path: 'new',
        name: 'pos-invoice',
        component: () => import('@/pages/Sales/SalesPoints/Edit.vue'),
        meta: {
          pageTitle: 'salesPoint',
          breadcrumb: [{ text: 'sales', active: true }],
          permission: 'addSalesTransactions',
        },
      },
      {
        path: 'edit/:id',
        name: 'pos-invoice-edit',
        props: true,
        component: () => import('@/pages/Sales/SalesPoints/Edit.vue'),
        meta: {
          pageTitle: 'salesPoint',
          breadcrumb: [{ text: 'sales', active: true }],
          permission: 'editSalesTransactions',
        },
      },
    ],
  },
  {
    path: '/concrete-sales-invoice',
    component: () => import('@/layouts/navigationIndex.vue'),
    children: [
      {
        path: 'new',
        name: 'concrete-sales-invoice',
        component: () => import('@/pages/Sales/ConcreteSalesInvoice/Edit.vue'),
        meta: {
          pageTitle: 'concreteSalesInvoice',
          breadcrumb: [{ text: 'sales', active: true }],
          permission: 'addConcreteTransactions',
        },
      },
      {
        path: 'edit/:id',
        name: 'concrete-sales-invoice-edit',
        props: true,
        component: () => import('@/pages/Sales/ConcreteSalesInvoice/Edit.vue'),
        meta: {
          pageTitle: 'concreteSalesInvoice',
          breadcrumb: [{ text: 'sales', active: true }],
          permission: 'editConcreteTransactions',
        },
      },
    ],
  },
  {
    path: '/quotation',
    component: () => import('@/layouts/navigationIndex.vue'),
    children: [
      {
        path: 'new',
        name: 'pos-quotation',
        component: () => import('@/pages/Sales/Quotation/Edit.vue'),
        meta: {
          pageTitle: 'quotation',
          breadcrumb: [{ text: 'sales', active: true }],
          permission: 'addQuotations',
        },
      },
      {
        path: 'edit/:id',
        name: 'pos-quotation-edit',
        props: true,
        component: () => import('@/pages/Sales/Quotation/Edit.vue'),
        meta: {
          pageTitle: 'quotation',
          breadcrumb: [{ text: 'sales', active: true }],
          permission: 'editQuotations',
        },
      },
    ],
  },
  {
    path: '/exchange-order',
    component: () => import('@/layouts/navigationIndex.vue'),
    children: [
      {
        path: 'new',
        name: 'exchange-order-new',
        component: () => import('@/pages/Sales/ExchangeOrder/Edit.vue'),
        meta: {
          pageTitle: 'newExchangeOrder',
          breadcrumb: [{ text: 'exchangeOrder', active: true }],
          permission: 'viewExchangeOrders',
        },
      },
      {
        path: 'edit/:id',
        name: 'exchange-order-edit',
        props: true,
        component: () => import('@/pages/Sales/ExchangeOrder/Edit.vue'),
        meta: {
          pageTitle: 'editExchangeOrder',
          breadcrumb: [{ text: 'exchangeOrder', active: true }],
          permission: 'editExchangeOrders',
        },
      },
    ],
  },
  {
    path: '/concrete-exchange-order',
    component: () => import('@/layouts/navigationIndex.vue'),
    children: [
      {
        path: 'new',
        name: 'concrete-exchange-order-new',
        component: () => import('@/pages/Sales/ConcreteExchangeOrder/Edit.vue'),
        meta: {
          pageTitle: 'newConcreteExchangeOrder',
          breadcrumb: [{ text: 'concreteExchangeOrder', active: true }],
          permission: 'addConcreteDelivery',
        },
      },
      {
        path: 'edit/:id',
        name: 'concrete-exchange-order-edit',
        props: true,
        component: () => import('@/pages/Sales/ConcreteExchangeOrder/Edit.vue'),
        meta: {
          pageTitle: 'editConcreteExchangeOrder',
          breadcrumb: [{ text: 'concreteExchangeOrder', active: true }],
          permission: 'editConcreteDelivery',
        },
      },
    ],
  },
  {
    path: '/return-sales',
    component: () => import('@/layouts/navigationIndex.vue'),
    children: [
      {
        path: 'new',
        name: 'return-sales-new',
        component: () => import('@/pages/Sales/ReturnSales/Edit.vue'),
        meta: {
          pageTitle: 'newReturnSales',
          breadcrumb: [{ text: 'returnSales', active: true }],
          permission: 'addReturnSalesTransactions',
        },
      },
      {
        path: 'edit/:id',
        name: 'return-sales-edit',
        props: true,
        component: () => import('@/pages/Sales/ReturnSales/Edit.vue'),
        meta: {
          pageTitle: 'editReturnSales',
          breadcrumb: [{ text: 'returnSales', active: true }],
          permission: 'editReturnSalesTransactions',
        },
      },
    ],
  },
];
